import { BannerAdsSection } from '~types/index'
import { GPTContainer, GPTSlot } from './GPT'

const BannerAdsSlide = ({
  id,
  path,
  size,
  skeleton,
  targeting,
  aspectRatio,
  shapeSquare,
  freezingTimeToLoad,
}: BannerAdsSection) => {
  return (
    <GPTContainer fallback={skeleton} freezingTime={freezingTimeToLoad}>
      <GPTSlot
        id={id}
        selector={id}
        adUnitPath={path}
        slotSize={size}
        fallback={skeleton}
        aspectRatio={aspectRatio}
        targeting={targeting}
        shapeSquare={shapeSquare}
      />
    </GPTContainer>
  )
}

export default BannerAdsSlide
